export const FetchTypes = {
    FETCH_ATTEMPT: "FETCH_ATTEMPT",
    FETCH_SUCCESS: "FETCH_SUCCESS",
    FETCH_FAIL: "FETCH_FAIL",
    FETCH_FORBIDDEN: "FETCH_FORBIDDEN", // if the user does not have access to the resource
    FETCH_CLEAR: "FETCH_CLEAR"
}